import React from 'react';

function TerminalIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" fill="none" viewBox="0 0 21 19">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M1 2a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2zm13 13a2 2 0 104 0 2 2 0 00-4 0z"
      ></path>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M8 3h7c2.761 0 5 3.134 5 7v5h-2m-4 0H6"
      ></path>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M14 3l1.5 7H20M7.5 8H15m-5-5v5M3 7v11"
      ></path>
    </svg>
  );
}

export default TerminalIcon;
